import React from 'react';
import SvgIcon from './SvgIcon';

const SendConfirm = props => (
    <SvgIcon viewBox="0 0 211 187" {...props}>
        <g id="1.13.20" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="5.2---Send-Confirmation-Modal" transform="translate(-534.000000, -361.000000)">
                <g id="Group-2" transform="translate(400.000000, 289.000000)">
                    <g id="send-confirm" transform="translate(135.000000, 72.000000)">
                        <g id="Group-7-Copy-2">
                            <circle
                                id="Oval"
                                fill="#EEF6FF"
                                fillRule="nonzero"
                                cx="101.03937"
                                cy="93.0393701"
                                r="93.0393701"
                            ></circle>
                            <ellipse
                                id="Oval"
                                fill="#3777BC"
                                fillRule="nonzero"
                                opacity="0.504"
                                cx="169.243598"
                                cy="165.910795"
                                rx="3.10186614"
                                ry="3.09189764"
                            ></ellipse>
                            <ellipse
                                id="Oval"
                                fill="#3777BC"
                                fillRule="nonzero"
                                opacity="0.28"
                                cx="115.601417"
                                cy="9.25243307"
                                rx="5.94787402"
                                ry="5.92959843"
                            ></ellipse>
                            <ellipse
                                id="Oval"
                                fill="#3777BC"
                                fillRule="nonzero"
                                cx="169.745346"
                                cy="58.4237402"
                                rx="1.94219685"
                                ry="1.93555118"
                            ></ellipse>
                            <ellipse
                                id="Oval"
                                fill="#3777BC"
                                fillRule="nonzero"
                                cx="30.0151654"
                                cy="81.4908583"
                                rx="3.65844094"
                                ry="3.64681102"
                            ></ellipse>
                            <g
                                id="Group"
                                transform="translate(172.787402, 9.968504)"
                                stroke="#3777BC"
                                strokeWidth="1.15634646"
                            >
                                <polygon
                                    id="Path"
                                    points="5.42452756 16.8700315 12.6982126 4.53899213 18.0180709 13.6252835 3.47070079 13.6252835 8.89855118 4.53899213 16.0642441 16.8700315"
                                ></polygon>
                                <ellipse
                                    id="Oval"
                                    cx="10.7443858"
                                    cy="10.7045118"
                                    rx="10.7443858"
                                    ry="10.7045118"
                                ></ellipse>
                            </g>
                            <g
                                id="Group"
                                transform="translate(0.000000, 24.921260)"
                                stroke="#3777BC"
                                strokeWidth="1.04004724"
                            >
                                <polygon
                                    id="Path"
                                    points="4.48084252 13.9359685 10.4885276 3.7498189 14.8829764 11.2544409 2.86594488 11.2544409 7.35011024 3.7498189 13.2697402 13.9359685"
                                ></polygon>
                                <ellipse
                                    id="Oval"
                                    cx="8.87529134"
                                    cy="8.84206299"
                                    rx="8.87529134"
                                    ry="8.84206299"
                                ></ellipse>
                            </g>
                            <g
                                id="Group"
                                transform="translate(39.874016, 151.188976)"
                                stroke="#3777BC"
                                strokeWidth="0.867259843"
                            >
                                <polygon
                                    id="Path"
                                    points="4.34792913 13.5222756 10.1778425 3.63850394 14.4427008 10.9221575 2.7812126 10.9221575 7.13246457 3.63850394 12.8759843 13.5222756"
                                ></polygon>
                                <ellipse
                                    id="Oval"
                                    cx="8.6127874"
                                    cy="8.58122047"
                                    rx="8.6127874"
                                    ry="8.58122047"
                                ></ellipse>
                            </g>
                            <ellipse
                                id="Oval"
                                fill="#D8D8D8"
                                fillRule="nonzero"
                                cx="207.957945"
                                cy="106.604843"
                                rx="1.94219685"
                                ry="1.93555118"
                            ></ellipse>
                        </g>
                        <g id="recipe-create" transform="translate(67.000000, 54.000000)" fillRule="nonzero">
                            <path
                                d="M66.0869565,3.47826087 L66.0869565,59.1304348 L55.6521739,80 L3.47826087,80 C1.55727044,80 0,78.4427296 0,76.5217391 L0,3.47826087 C0,1.55727044 1.55727044,0 3.47826087,0 L62.6086957,0 C64.5296861,0 66.0869565,1.55727044 66.0869565,3.47826087 Z"
                                id="Path"
                                fill="#A4C3E4"
                            ></path>
                            <path
                                d="M50.4347826,20.8695652 L29.5652174,20.8695652 C28.6047222,20.8695652 27.826087,20.09093 27.826087,19.1304348 C27.826087,18.1699396 28.6047222,17.3913043 29.5652174,17.3913043 L50.4347826,17.3913043 C51.3952778,17.3913043 52.173913,18.1699396 52.173913,19.1304348 C52.173913,20.09093 51.3952778,20.8695652 50.4347826,20.8695652 Z"
                                id="Path"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M50.4347826,34.7826087 L29.5652174,34.7826087 C28.6047222,34.7826087 27.826087,34.0039735 27.826087,33.0434783 C27.826087,32.082983 28.6047222,31.3043478 29.5652174,31.3043478 L50.4347826,31.3043478 C51.3952778,31.3043478 52.173913,32.082983 52.173913,33.0434783 C52.173913,34.0039735 51.3952778,34.7826087 50.4347826,34.7826087 Z"
                                id="Path"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M36.5217391,48.6956522 L29.5652174,48.6956522 C28.6047222,48.6956522 27.826087,47.917017 27.826087,46.9565217 C27.826087,45.9960265 28.6047222,45.2173913 29.5652174,45.2173913 L36.5217391,45.2173913 C37.4822343,45.2173913 38.2608696,45.9960265 38.2608696,46.9565217 C38.2608696,47.917017 37.4822343,48.6956522 36.5217391,48.6956522 Z"
                                id="Path"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M33.0434783,62.6086957 L15.6521739,62.6086957 C14.6916787,62.6086957 13.9130435,61.8300604 13.9130435,60.8695652 C13.9130435,59.90907 14.6916787,59.1304348 15.6521739,59.1304348 L33.0434783,59.1304348 C34.0039735,59.1304348 34.7826087,59.90907 34.7826087,60.8695652 C34.7826087,61.8300604 34.0039735,62.6086957 33.0434783,62.6086957 Z"
                                id="Path"
                                fill="#FFFFFF"
                            ></path>
                            <circle id="Oval" fill="#8AA9CA" cx="17.3913043" cy="19.1304348" r="3.47826087"></circle>
                            <circle id="Oval" fill="#8AA9CA" cx="17.3913043" cy="33.0434783" r="3.47826087"></circle>
                            <circle id="Oval" fill="#8AA9CA" cx="17.3913043" cy="46.9565217" r="3.47826087"></circle>
                            <path
                                d="M40,62.6086957 C40,72.2136478 47.7863522,80 57.3913043,80 C66.9962565,80 74.7826087,72.2136478 74.7826087,62.6086957 C74.7826087,53.0037435 66.9962565,45.2173913 57.3913043,45.2173913 C47.7907227,45.2279346 40.0105433,53.008114 40,62.6086957 Z"
                                id="Path"
                                fill="#3777BC"
                            ></path>
                            <path
                                d="M67.3165217,56.1617391 C67.9954468,56.8408693 67.9954468,57.9417394 67.3165217,58.6208696 L55.1426087,70.7947826 C54.4634785,71.4737077 53.3626084,71.4737077 52.6834783,70.7947826 L47.466087,65.5773913 C46.8070049,64.8949932 46.8164307,63.8102873 47.487272,63.139446 C48.1581134,62.4686046 49.2428193,62.4591788 49.9252174,63.1182609 L53.9130435,67.106087 L64.8573913,56.1617391 C65.5365215,55.482814 66.6373916,55.482814 67.3165217,56.1617391 Z"
                                id="Path"
                                fill="#FFFFFF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

SendConfirm.displayName = 'SendConfirmIcon';

export default SendConfirm;
